import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { ITermsConditionsStatus } from 'types/terms-conditions'

type IdParams = { tenderId: string }

export const termsConditionsApi = createApi({
  reducerPath: 'terms-conditions',
  baseQuery,
  tagTypes: ['TermsConditions'],
  endpoints: (builder) => ({
    termsConditionsStatus: builder.query<ITermsConditionsStatus, IdParams>({
      query: ({ tenderId }) => {
        const params = new URLSearchParams()

        params.set('tenderId', tenderId)

        return {
          url: '/terms-conditions/status',
          method: 'get',
          params,
        }
      },
      providesTags: ['TermsConditions'],
    }),

    acceptTermsConditions: builder.mutation<void, IdParams>({
      query: ({ tenderId }) => {
        const params = new URLSearchParams()

        params.set('tenderId', tenderId)

        return {
          url: '/terms-conditions/accept',
          method: 'post',
          params,
        }
      },
      invalidatesTags: ['TermsConditions'],
    }),
  }),
})

export const { useTermsConditionsStatusQuery, useAcceptTermsConditionsMutation } =
  termsConditionsApi
